export default __webpack_public_path__ + "static/media/gallery_08.2aa118a2.jpg";